import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ICON_TYPE, ViewModes } from '@spartacus/storefront'

@Component({
    selector: 'app-custom-product-view',
    templateUrl: './custom-product-view.component.html',
    styleUrls: ['./custom-product-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomProductViewComponent implements OnInit {
  iconTypes = ICON_TYPE
  @Input()
  mode: ViewModes = ViewModes.Grid
  @Output()
  modeChange = new EventEmitter<string>()

  get buttonClass(): string {
    const viewName: string = this.viewMode.toLowerCase()
    return `cx-product-${viewName}`
  }

  /**
   *   Display icons inversely to allow users
   *   to see the view they will navigate to
   */
  get viewMode(): ICON_TYPE {
    if (this.mode === 'list') {
      return this.iconTypes.GRID
    } else if (this.mode === 'grid') {
      return this.iconTypes.LIST
    }
  }

  changeMode(): void {
    const newMode = this.mode === ViewModes.Grid ? ViewModes.List : ViewModes.Grid
    this.modeChange.emit(newMode)
  }

  ngOnInit(): void {}
}
